module.exports = __webpack_public_path__ + "img/A58A0209_min.32ff0bbe.jpg";